














import { mountOnBody } from 'library/services/helpers'
import AnnouncementModal from './modal'

export default

	props: announcement: Object

	data: ->
		dropdownOpen: false

	computed:
		type: -> @announcement.__typename
		isLink: -> @type is "announcementBar_link_BlockType"
		isExpanding: -> @type is "announcementBar_expanding_BlockType"

		bannerText: -> @announcement.bannerCopy

		expandingText: -> @announcement.expandingCopy

		messageType: ->
			if @isLink then 'smart-link'
			else if @isExpanding then 'button'
			else 'div'

		config: -> {
			to: @announcement.url if @isLink
		}

		expandingToggle: ->
			unless @isExpanding then {}
			else {
				click: @mountAnnouncementModal
			}


	methods:
		mountAnnouncementModal: ->
			await mountOnBody AnnouncementModal,
				parent: this
				propsData:
					body: @expandingText
					buttons: @announcement.buttons



